module.exports = "<h1>{{ $ctrl.card.title | gettext }}</h1><div ng-repeat=\"item in $ctrl.card.items\"><table><tr ng-repeat=\"key in $ctrl.card.keys track by $index\" ng-if=\"$ctrl.keysFilter.indexOf(key) === -1 && item[key]\"><td width=\"30%\"><b>{{ $ctrl.card.labels[$index] }}</b></td><td>{{:: item[key] | gettext}}</td></tr></table></div>"


//////////////////
// WEBPACK FOOTER
// ./src/view/dashboard/card.component.html
// module id = 407
// module chunks = 0